import axios from "axios";

const BASE = process.env.REACT_APP_WOW_SIGN_API_BASE_URL;

export const getSignerPreview = (token) =>
  axios.get(`${BASE}/signer-access/${token}/preview`);

export const sendOtp = (token) =>
  axios.post(`${BASE}/signer-access/${token}/send-otp`);

export const verifyOtp = (data) =>
  axios.post(`${BASE}/signer-access/verify-otp`, data);

export const signField = (documentId, payload) =>
  axios.post(`${BASE}/esign/${documentId}/sign`, payload);

export const signAllFields = (documentId, payload) =>
  axios.post(`${BASE}/esign/${documentId}/sign-all`, payload);

export const rejectSigning = (documentId, payload) =>
  axios.post(`${BASE}/esign/${documentId}/reject`, payload);